module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail_list_sp-16d9e83f6b18f83924868b67fa760f5d.jpg";